































import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';

@Component
export default class AddNewTicketThanks extends Vue {
    constructor() {
        super();
    }

    get mode(): string {
        return this.$store.getters['UserTickets/getAddNewTicketThanksMode'];
    }

    public close() {
        this.$store.commit(Mutations.RESET_HOME_ASSISTANT_STORE_STATE);
        this.$store.commit(Mutations.RESET_INQUIRY_ANSWER);
        this.$store.commit(Mutations.RESET_ISSUE_REPORT_STORE_STATE);

        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_THANKS_VISIBILITY, false);
        this.$store.commit(Mutations.SET_TICKET_CREATE_FORM_OVERLAY_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_THANKS_MODE, 'NotNewTicket');
    }

    public cancel() {
        this.close();

        if (this.$router.currentRoute.name !== 'tickets') {
            this.$router.push({ name: 'tickets' });
        }
    }
}
